import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'atram-datepicker',
  templateUrl: './atram-datepicker.component.html',
  styleUrls: ['./atram-datepicker.component.less']
})
export class AtramDatepickerComponent implements OnInit {

  @Input()
  parentFormGroup!: FormGroup;
  @Input()
  type: string = 'text';
  @Input()
  controlName!: string;
  @Input()
  label!: string;
  @Input()
  placeholder!: string;
  @Input()
  maxlength!: string;
  @Input()
  textColor: string = 'black';
  @Input() showSearchButton: boolean | undefined = false;
  @Input() isRequired: boolean | undefined = false;
  @Input() isError: boolean | undefined = false;
  @Input() isDisabled: boolean | undefined = false;
  @Input()
  componentClass!: string;
  @Output('on-search') onSearchEmitter: EventEmitter<string>;
  @Output('on-click') onClickEmitter: EventEmitter<any>;

  constructor() {
    this.onSearchEmitter = new EventEmitter<string>();
    this.onClickEmitter = new EventEmitter<void>();
 }

  ngOnInit() {
  }

  public onSearch(event: Event): void {
    let value: any = (event.target as HTMLInputElement).value;
    this.onSearchEmitter.emit(value);
  }

  public onClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    this.onClickEmitter.emit(event);
  }
}
